import { useState } from "react";
import { parseJsonField } from "../../utils/parseJsonField";
import "../../css/pageLayout.css"

function AccordionSection({ section }) {
  const settings = parseJsonField(section.settings_json);
  const items = section.items || [];

  return (
    <section className="accordion-section">
      {settings.title && <h2>{settings.title}</h2>}

      {items
        .filter((item) => item.is_visible !== false)
        .map((item) => (
          <AccordionItem key={item.id} item={item} />
        ))}
    </section>
  );
}

function AccordionItem({ item }) {
  const content = parseJsonField(item.content_json);
  const [open, setOpen] = useState(Boolean(content.is_open_default));

  return (
    <div className={`accordion-item ${open ? "open" : ""}`}>
      <button
        className="accordion-title"
        onClick={() => setOpen(!open)}
      >
        <span className="accordion-arrow">
          {open ? "▼" : "▶"}
        </span>

        <span className="accordion-text">
          {content.title}
        </span>
      </button>

      {open && (
        <div
          className="accordion-body"
          dangerouslySetInnerHTML={{ __html: content.body || "" }}
        />
      )}
    </div>
  );
}

export default AccordionSection;